export const AllowedOrderByValues = ['ASC', 'DESC'] as const;
export type OrderBy = (typeof AllowedOrderByValues)[number];
